import { object, string } from 'yup'

export const criteriaSchema = object({
  name: string().required('Criteria name is required'),
})

export const defaultInitialCriteriaValues = {
  name: '',
};